"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICON_SPRITE_TYPES = void 0;
var ICON_SPRITE_TYPES;
(function (ICON_SPRITE_TYPES) {
    ICON_SPRITE_TYPES["ALERTS_AND_FEEDBACK"] = "alerts-and-feedbacks";
    ICON_SPRITE_TYPES["ARROWS"] = "arrows";
    ICON_SPRITE_TYPES["CHARTS"] = "charts";
    ICON_SPRITE_TYPES["COMMUNICATION"] = "communication";
    ICON_SPRITE_TYPES["COUNTRY_SET_1"] = "country-set-1";
    ICON_SPRITE_TYPES["COUNTRY_SET_2"] = "country-set-2";
    ICON_SPRITE_TYPES["CRYPTO_SET_1"] = "crypto-set-1";
    ICON_SPRITE_TYPES["CRYPTO_SET_2"] = "crypto-set-2";
    ICON_SPRITE_TYPES["CRYPTO_SET_3"] = "crypto-set-3";
    ICON_SPRITE_TYPES["EDITOR"] = "editor";
    ICON_SPRITE_TYPES["EDUCATION"] = "education";
    ICON_SPRITE_TYPES["FILES"] = "files";
    ICON_SPRITE_TYPES["FINANCE_AND_ECOMMERCE"] = "finance-and-ecommerce";
    ICON_SPRITE_TYPES["GENERAL"] = "general";
    ICON_SPRITE_TYPES["LAYOUT"] = "layout";
    ICON_SPRITE_TYPES["SECURITY"] = "security";
    ICON_SPRITE_TYPES["TIME"] = "time";
    ICON_SPRITE_TYPES["USERS"] = "users";
    ICON_SPRITE_TYPES["COUNTRY_FLAGS"] = "country-flags";
    ICON_SPRITE_TYPES["FIAT_CURRENCIES"] = "fiat-currencies";
    ICON_SPRITE_TYPES["WEATHER"] = "weather";
})(ICON_SPRITE_TYPES = exports.ICON_SPRITE_TYPES || (exports.ICON_SPRITE_TYPES = {}));
